<template>
  <Notifications
    id="notifications-container"
    position="top right"
    width="400"
    class="tw-pointer-events-none"
  >
    <template #body="{ item, close }">
      <div class="tw-px-1">
        <div
          class="!tw-pointer-events-auto tw-mb-2 tw-rounded-lg tw-p-4 tw-shadow"
          :class="types[item.type].container"
        >
          <div class="tw-flex tw-items-center tw-space-x-4">
            <div class="tw-shrink-0">
              <component
                :is="types[item.type].icon"
                :class="[types[item.type].iconColor, types[item.type].iconSize]"
              />
            </div>
            <div class="tw-grow">
              <p class="tw-text-sm" :class="[types[item.type].textColor]">
                {{ item.text }}
              </p>
            </div>
            <div class="tw-flex tw-shrink-0">
              <button
                @click="close"
                class="tw--m-2 tw-inline-flex tw-rounded-full tw-p-2 tw-text-neutral-500 hover:tw-text-neutral-600 focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-neutral-200"
              >
                <span class="tw-sr-only">Close</span>
                <CloseIcon class="tw-h-[14px] tw-w-[14px]" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Notifications>
</template>

<script setup>
import CheckIcon from '@/assets/images/icons/check-full.svg'
import InfoIcon from '@/assets/images/icons/info.svg'
import CloseIcon from '@/assets/images/icons/close.svg'
import { useNotificationsContainerPosition } from '@/shared/composables/useNotificationsContainerPosition'

useNotificationsContainerPosition('notifications-container')

const types = {
  success: {
    container: 'tw-bg-white',
    icon: CheckIcon,
    iconSize: 'tw-w-5 tw-h-5',
    iconColor: 'tw-text-success-500',
    textColor: 'tw-text-success-500',
  },
  error: {
    container: 'tw-bg-white',
    icon: InfoIcon,
    iconSize: 'tw-w-5 tw-h-5',
    iconColor: 'tw-text-error-500',
    textColor: 'tw-text-error-500',
  },
}
</script>

<style>
.vue-notification-group {
  @apply !tw-z-[999];
}
#notifications-container span > *:first-child {
  @apply tw--mt-6;
}
#notifications-container span > *:not(:first-child) {
  @apply tw--mt-16;
}
</style>
